import type { Identify, Types } from "@amplitude/analytics-browser";
import type { Identity } from "@wb/ui/analytics/useIdentity";

declare global {
  interface Window {
    amplitude?: Types.BrowserClient & {
      Identify: typeof Identify;
    };
  }
}

export const identity: Identity = (id, email) => {
  const amplitude = window.amplitude;

  if (!amplitude) {
    return;
  }

  amplitude.setUserId(id);

  if (email) {
    const identify = new amplitude.Identify();
    identify.set("email", email);
    amplitude.identify(identify);
  }
};
